import React from "react";
import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { LayoutDashboard, FolderTree, Package, ShoppingCart, Bot, Sparkles, Settings, LogOut, Search, FileText } from "lucide-react";
import { ThemeToggle } from "../../components/ui/theme-toggle";

const navItems = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/categories", label: "Categories", icon: FolderTree },
  { to: "/admin/packages", label: "Packages", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admin/bot", label: "Bot Training", icon: Bot },
  { to: "/admin/festival", label: "Festival", icon: Sparkles },
  { to: "/admin/seo", label: "SEO", icon: Search },
  { to: "/admin/blogs", label: "Blogs", icon: FileText },
];

export default function AdminLayout() {
  const { user, logout, ready } = useAuth();
  const nav = useNavigate();
  if (!ready) return <div className="p-10">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex bg-card/40" data-testid="admin-layout">
      <aside className="w-60 bg-background border-r border-border flex flex-col">
        <div className="p-6 border-b border-border">
          <div className="flex items-center justify-between w-full">
            <div>
              <div className="font-serif-display text-xl">Admin</div>
              <div className="text-xs text-muted-foreground">{user.email}</div>
            </div>
            <ThemeToggle />
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition ${isActive ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`}
              data-testid={`nav-${it.to.split("/").pop()}`}
            >
              <it.icon className="w-4 h-4" /> {it.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={() => { logout(); nav("/admin/login"); }} className="m-3 flex items-center gap-2 px-3 py-2 rounded-lg text-sm hover:bg-muted" data-testid="logout-btn">
          <LogOut className="w-4 h-4" /> Logout
        </button>
      </aside>
      <main className="flex-1 p-6 sm:p-10 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
